import type { AuthResponse, LoginRequest, RegisterRequest } from '@ember/types';
import { api } from './api.js';

export async function login(email: string, password: string): Promise<AuthResponse> {
  const body: LoginRequest = { email, password };
  return api.post<AuthResponse>('/api/auth/login', body);
}

export async function register(
  email: string,
  password: string,
  displayName: string,
  inviteToken?: string,
): Promise<AuthResponse> {
  const body: RegisterRequest = { email, password, displayName, inviteToken };
  return api.post<AuthResponse>('/api/auth/register', body);
}

export async function logout(): Promise<void> {
  await api.post('/api/auth/logout');
}
